import './set-customer-rating.modal.scss';

export default function SetCustomerRatingModal($scope, close, $t, request) {
  'ngInject';

  $scope.ratingModal = {
    rating: 5,
    request: request
  };

  if ($scope.ratingModal.request.organisation && $scope.ratingModal.request.organisation.id) {
    $scope.ratingModal.request.customer = $scope.ratingModal.request.organisation;
  } else if ($scope.ratingModal.request.bicycleOwner) {
    $scope.ratingModal.request.customer = {
      name: $scope.ratingModal.request.bicycleOwner.name + ' ' + $scope.ratingModal.request.bicycleOwner.surname,
      image: $scope.ratingModal.request.bicycleOwner.avatar
    };
  }

  $scope.ok = (form) => {
    if (form.$valid) {
      const result = {
        rating: $scope.ratingModal.rating,
        comment: $scope.ratingModal.comment
      };

      close(result);
    }
  }

}